export const boardTodoTour = {
  key: "boardTodo",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-todo-topbar"]',
      content: t("Tour_BoardTodo_Topbar"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-todo-addtask"]',
      content: t("Tour_BoardTodo_AddTask"),
      placement: "left",
    },
    {
      target: '[data-tour="board-todo-filter"]',
      content: t("Tour_BoardTodo_Filter"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-todo-temporarygoals"]',
      content: t("Tour_BoardTodo_TemporaryGoals"),
      placement: "top",
    },
    {
      target: '[data-tour="board-todo-activesprints"]',
      content: t("Tour_BoardTodo_ActiveSprints"),
      placement: "top",
    },
    {
      target: '[data-tour="board-todo-columns"]',
      content: t("Tour_BoardTodo_DragDrop"),
      placement: "top",
    },
  ],
};